import React, { useState } from "react";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import PdfPickerDialog from "../PdfPickerDialog";

const QuestionFormPdf = ({ value, onChange }) => {
    const v = value || {};
    const [pickerOpen, setPickerOpen] = useState(false);

    const onPickPdf = (pdf) => {
        onChange({
            ...v,
            pdfPath: pdf.url,
            pdfFileName: pdf.originalFilename || pdf.filename || v.pdfFileName || "document.pdf",
        });
        setPickerOpen(false);
    };

    return (
        <Stack spacing={2}>
            <Typography variant="subtitle2">PDF</Typography>

            <TextField
                label="Підзаголовок"
                value={v.subtitle || ""}
                onChange={(e) => onChange({ ...v, subtitle: e.target.value })}
                fullWidth
            />

            <TextField
                label="Назва / опис"
                value={v.question || ""}
                onChange={(e) => onChange({ ...v, question: e.target.value })}
                fullWidth
                multiline
                minRows={2}
            />

            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }}>
                <TextField
                    label="pdfPath"
                    value={v.pdfPath || ""}
                    onChange={(e) => onChange({ ...v, pdfPath: e.target.value })}
                    fullWidth
                />
                <Button variant="outlined" onClick={() => setPickerOpen(true)} sx={{ minWidth: 170 }}>
                    Обрати PDF
                </Button>
            </Stack>

            <TextField
                label="pdfFileName"
                value={v.pdfFileName || ""}
                onChange={(e) => onChange({ ...v, pdfFileName: e.target.value })}
                helperText="Назва файла для кнопки завантаження."
                fullWidth
            />

            {v.pdfPath && (
                <Box sx={{ p: 1.5, border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
                    <Typography variant="body2" fontWeight={700}>
                        {v.pdfFileName || "PDF"}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
                        {v.pdfPath}
                    </Typography>
                </Box>
            )}

            <PdfPickerDialog
                open={pickerOpen}
                onClose={() => setPickerOpen(false)}
                onPick={onPickPdf}
            />
        </Stack>
    );
};

export default QuestionFormPdf;
